import React from 'react';

const Library = () => {
  return <div><h1>Library</h1></div>;
};

export default Library;
